/**
 * 快捷键store
 */
import { defineStore } from 'pinia'

import {
  getDetailFastSet,
  fastReplyAllList,
  IFastGroupRequestParam,
  Type,
  FastReplyResponse
} from '@/server/user_fast_request'
import { throttle } from 'lodash'
interface IHotKeyStoreParam {
  sendKey: string
  newLine: string
  endSession: string
  fastReplyList: FastReplyResponse[] | undefined
  fastReplyRefreshKey: number
}
/**
 * 快捷键设置
 */
export const useHotKeyStore = defineStore('hotkey', {
  state: (): IHotKeyStoreParam => {
    return {
      sendKey: 'Enter',
      newLine: 'Ctrl+Enter',
      endSession: 'F2',
      fastReplyList: undefined,
      fastReplyRefreshKey: 0
    }
  },
  actions: {
    /**
     * 获取快捷键详情
     */
    async getHotKeyDetail() {
      await getDetailFastSet().then((res) => {
        if (res && res.code == '0') {
          // 发送固定为回车。
          // 服务端给每个客服存的默认值是「Ctrl+Enter 发送、Enter 换行」，和客服的习惯相反，
          // 以前每个客服都得自己改设置，改之前按回车只会换行、发不出去。
          this.sendKey = 'Enter'
          // 换行用 Ctrl+Enter（或客服自己选了 Shift+Enter）。服务端存的是 Enter（和发送冲突）或没设置时，用 Ctrl+Enter。
          this.newLine = res?.data?.dialogNewline === 'Shift+Enter' ? 'Shift+Enter' : 'Ctrl+Enter'
          this.endSession = res?.data?.endSession ?? 'F2'
        }
      })
    },
    getFastReplyShortcutKeyList() {
      return (this.fastReplyList || []).filter((item) => item.shortcuts)
    },
    async queryFastReplyList(param: IFastGroupRequestParam = { type: Type.Employee }) {
      await fastReplyAllList(param).then((res) => {
        this.fastReplyList = res.data || []
      })
    },
    async loadOnce() {
      if (!this.fastReplyList || this.fastReplyList.length === 0) {
        throttle(async () => await this.queryFastReplyList(), 1000)
      } else {
        console.log('快捷回复列表已存在 不进行加载！！！')
      }
    },
    updateFastReply(fastReply: FastReplyResponse) {
      //
      if (this.fastReplyList && this.fastReplyList.length > 0) {
        //
        const activeIndex = this.fastReplyList.findIndex((item) => item.id === fastReply.id)
        if (activeIndex != -1) {
          this.fastReplyList[activeIndex] = fastReply
        } else {
          this.fastReplyList.push(fastReply)
        }
      } else {
        this.fastReplyList = [fastReply]
      }
      this.fastReplyRefreshKey++
    },
    delFastReply(fastReply: FastReplyResponse) {
      //
      console.log(this.fastReplyList)
      if (this.fastReplyList && this.fastReplyList.length > 0) {
        //
        this.fastReplyList=this.fastReplyList.filter(function (item) {
          return item.shortcuts !== fastReply.shortcuts;
      });
      } 
      this.fastReplyRefreshKey++
    },
    /**
     * 设置快捷键
     *
     * @param value
     */
    setHotKey(value: string) {
      if (!value) return
      this.sendKey = value
    }
  },
  persist: {
    storage: sessionStorage
  }
})
